import React from 'react';

interface FieldErrorTextProps {
    id?: string;
    message?: string;
}

export function FieldErrorText({ id, message }: FieldErrorTextProps) {
    if (!message) return null;
    return (
        <p id={id} className="text-xs text-red-600">
            {message}
        </p>
    );
}

